import React, { useState, useEffect } from 'react';
import { DataTable, Filter, PageWrapper } from '../../components';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { DriverApplicationStatus, DriverType, Pages } from '../../shared/enums';
import { useTranslation } from 'react-i18next';
import { getDriverApplicationList } from '../../api/driver-application';
import dayjs from 'dayjs';
import { DATETIME_FORMAT } from '../../shared/constants';

const DriverApplication = () => {
    const { t } = useTranslation()
    const navigate = useNavigate();
    const [filter, setFilter] = useState({});
    const [pagination, setPagination] = useState({ page: 1, pageSize: 25 });
    const [totalPages, setTotalPage] = useState(0);
    const [data, setData] = useState([]);

    const handleFilterChange = (newFilter) => {
        setFilter(newFilter);
        setPagination(prev => ({ ...prev, page: 1 })); // Reset to page 1 when filter changes
    };

    const columns = [
        { key: "createdAt", label: t("CREATED_AT"), render: (createdAt, data) => dayjs(createdAt).format(DATETIME_FORMAT) },
        { key: "fullName", label: t("FULL_NAME"), },
        { key: "phoneNumber", label: t("PHONE_NUMBER"), render: (phoneNumber, data) => data.countryCode + data.phoneNumber },
        { key: "email", label: t("EMAIL") },
        { key: "driverType", label: t("DRIVER_TYPE"), },
        { key: "gender", label: t("GENDER") },
        { key: "status", label: t("STATUS") },
        {
            key: "action", label: t("ACTION"), render: (v, data) => <Dropdown>
                <Dropdown.Toggle variant="primary" size="sm" className='py-0'></Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => navigate(Pages.DriverApplicationDetail.replace(":id", data.id))}>{t("EDIT")}</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        }
    ]

    const filters = [
        { type: "input", label: t("SEARCH"), name: "search" },
        { type: "select", label: t("STATUS"), name: "status", options: [{ label: "All", value: "" }, ...Object.entries(DriverApplicationStatus).map(([key, value]) => ({ label: t(key), value: value }))] },
        { type: "select", label: t("DRIVER_TYPE"), name: "driverType", options: [{ label: "All", value: "" }, ...Object.entries(DriverType).map(([key, value]) => ({ label: t(key), value: value }))] }
    ]

    useEffect(() => {
        getData(pagination, filter)
    }, [pagination, filter])


    const getData = async (pagination, filter) => {
        const response = await getDriverApplicationList({ skip: (pagination?.page - 1) * pagination?.pageSize, limit: pagination?.pageSize, ...filter })
        setData(response.items)
        setTotalPage(Math.ceil(response?.pagination?.total / pagination?.pageSize))
    }

    return (
        <PageWrapper headerProps={{ title: "DRIVER_APPLICATION" }}>
            <Filter filters={filters} onChangeFilter={handleFilterChange} />
            <DataTable columns={columns} data={data} pagination={{ ...pagination, totalPages, onChange: setPagination }} />
        </PageWrapper>
    );
};

export default DriverApplication;
